let accessToken = '';

export const getAccessToken = () => accessToken;

export const setAccessToken = (token: string | null | undefined) => {
  accessToken = String(token || '').trim();
};

export const clearAccessToken = () => {
  accessToken = '';
};
